<script lang="ts">
    import SectionHeader from "../components/SectionHeader.svelte";
    import UserProfilePanel from "@/pages/settings/pages/userProfile/App.svelte";
</script>

<div class="dashStack">
    <SectionHeader id="profile" />
    <div class="referralsPanel partnerProfilePanel">
        <UserProfilePanel embedded={true} />
    </div>
</div>
